module.exports = __webpack_public_path__ + "static/media/bez_temp_w_domu_czuwanie_4.22e46504.svg";